import axios from 'axios';
import Config from '../../config';
import {flashMessage} from 'redux-flash';

export function get() {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/Media', Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MEDIA_GET_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                return response;
            }
        })
    }
}

export function single(id) {
    return (dispatch) => {
        return axios.get(Config.api.getCdnEndPoint() + 'api/Media/' + id, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MEDIA_SINGLE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'MediaItemEditForm',
                        keepDirty: undefined
                    },
                    payload: response.data
                });

                return response;
            }
        })
    }
}

export function post(values) {
    return (dispatch) => {
        const uploaders = values.files.map(file => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("timestamp", (Date.now() / 1000) | 0);

            return axios.post(Config.api.endpoint + 'api/Media/files' + (values.workspaceId ? "?workspaceId=" + values.workspaceId : ""), formData, Config.getApiConfig({
                headers: {"X-Requested-With": "XMLHttpRequest"},
            })).then(response => {
                if (response && response.data) {
                    //dispatch(flashMessage('File uploaded!', {timeout: 3000, props: {type: 'success'}}));

                    dispatch({type: 'MEDIA_FILE_UPLOAD_FINISH'});
                    return response;
                } else {
                    //const data = response.data;
                    //dispatch(flashMessage('File uploaded Failed!', {timeout: 3000, props: {type: 'error'}}));
                    dispatch({type: 'MEDIA_FILE_UPLOAD_FINISH'});
                    dispatch({type: 'MEDIA_FILE_UPLOAD_FAILED'});
                    return false;
                }
            }).catch(error => {
                dispatch({type: 'MEDIA_FILE_UPLOAD_FINISH'});
                dispatch({type: 'MEDIA_FILE_UPLOAD_FAILED'});
                return false;
            });
        });
        dispatch({type: 'MEDIA_UPLOAD_START', payload: values.files.length});

        return axios.all(uploaders).then(response => {
            if (response) {
                var wasSucces = true;
                var data = [];
                var failedCount = 0;
                var fileCount = 0;
                for (var x in response) {
                    fileCount++;
                    data.push(response[x]);
                    if (!response[x]) {
                        wasSucces = false;
                        failedCount++;
                    } else {

                    }
                }
                response.data = data;

                if (wasSucces) {
                    dispatch(flashMessage('All Medial files uploaded!', {
                        timeout: 3000,
                        props: {type: 'success'}
                    }));
                    dispatch({type: 'MEDIA_UPLOAD_FINISH'});
                    dispatch({
                        type: 'MEDIA_CLOSE_MEDIA_UPLOAD',
                        payload: false
                    });
                    //Updating media list
                    dispatch(get());
                    return true;
                } else {
                    dispatch(flashMessage('Some files upload failed ( ' + failedCount + ' from ' + fileCount + ' file/files failed )!', {
                        timeout: 6000,
                        props: {type: 'error'}
                    }));
                    dispatch({type: 'MEDIA_UPLOAD_FINISH'});
                    dispatch({
                        type: 'MEDIA_CLOSE_MEDIA_UPLOAD',
                        payload: false
                    });
                    //Updating media list
                    dispatch(get());
                    return false;
                }
            } else {
                dispatch(flashMessage('Some files upload failed!', {
                    timeout: 3000,
                    props: {type: 'error'}
                }));
                dispatch({type: 'MEDIA_UPLOAD_FINISH'});
                dispatch({type: 'MEDIA_CLOSE_MEDIA_UPLOAD', payload: false});
                //Updating media list
                dispatch(get());
                return response;
            }
        }).catch(error => {
            dispatch({
                type: 'MEDIA_UPLOAD_FINISH',
                payload: false
            });
            dispatch({type: 'MEDIA_CLOSE_MEDIA_UPLOAD', payload: false});

            //Updating media list
            dispatch(get());
        });
    }
}

export function put(values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/Media/update', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MEDIA_PUT_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: 'MEDIA_REFRESH_TRUE'
                });

                dispatch(flashMessage('Media item updated!', {
                    timeout: 3000,
                    props: {type: 'success'}
                }));

                //Updating media list
                dispatch(get());
                return response;
            }
        })
    }
}

export function putBulk(listOfItems) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/Media/bulkUpdate', listOfItems, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MEDIA_PUT_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({type: 'MEDIA_REFRESH_TRUE'});

                dispatch(flashMessage('Media items ('+listOfItems.length+') updated!', {
                    timeout: 3000,
                    props: {type: 'success'}
                }));

                //Updating media list
                dispatch(get());
                return response;
            }
        })
    }
}


export function setMediaItemForDelete(id) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SET_ITEM_FOR_DELETION',
            payload: id
        });

        return Promise.resolve(true);
    }
}

export function setMediaItemForEdit(id) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SET_ITEM_FOR_EDIT',
            payload: id
        });

        return Promise.resolve(true);
    }
}

export function destroy(id) {
    return (dispatch) => {
        return axios.delete(Config.api.endpoint + 'api/Media/' + id, Config.getApiConfig()).then(() => {
            dispatch({
                type: 'MEDIA_DESTROY_SUCCESS'
            });
            dispatch(flashMessage('Media item deleted successfully!', {
                timeout: 3000,
                props: {type: 'success'}
            }));
            //Updating media list
            dispatch(get());
            return Promise.resolve(true);
        });
    }
}

export function destroyBulk(ids) {

    const queryParamsString = "ids="+ids.join("&ids=");

    return (dispatch) => {
        return axios.delete(Config.api.endpoint + 'api/Media/bulkDelete?' + queryParamsString, Config.getApiConfig()).then(() => {
            dispatch({
                type: 'MEDIA_DESTROY_SUCCESS'
            });
            dispatch(flashMessage('Media items (' + ids.length + ') deleted successfully!', {
                timeout: 3000,
                props: {type: 'success'}
            }));
            //Updating media list
            dispatch(get());
            return Promise.resolve(true);
        });
    }
}

///

export function refreshTrue() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_REFRESH_TRUE'
        });

        return Promise.resolve(true);
    }
}

export function refreshFalse() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_REFRESH_FALSE'
        });

        return Promise.resolve(true);
    }
}

export function finishUpload() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_UPLOAD_FINISH',
            payload: false
        });

        return Promise.resolve(true);
    }
}

export function showUploadModal() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SHOW_MEDIA_UPLOAD',
            payload: true
        });

        return Promise.resolve(true);
    }
}

export function hideUploadModal() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_CLOSE_MEDIA_UPLOAD',
            payload: false
        });

        return Promise.resolve(true);
    }
}

export function showSelectModal(name) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SHOW_SELECT_MODAL',
            payload: {
                name: name
            }
        });

        return Promise.resolve(true);
    }
}

export function hideSelectModal() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_CLOSE_SELECT_MODAL',
            payload: false
        });

        return Promise.resolve(true);
    }
}

export function selectMediaItems(mediaItems) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SELECTED_ITEMS',
            payload: mediaItems
        });

        return Promise.resolve(true);
    }
}

export function selectMediaItemsReset() {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SELECTED_ITEMS_RESET',
            payload: true
        });

        return Promise.resolve(true);
    }
}

export function setMediaSearchKeyword(keyword) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SET_SEARCH_KEYWORD',
            payload: keyword
        });

        return Promise.resolve(true);
    }
}

export function setMediaWorkspace(workspaceId) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SET_WORKSPACE',
            payload: workspaceId
        });

        return Promise.resolve(true);
    }
}

export function setMediaType(mediaType) {
    return (dispatch) => {
        dispatch({
            type: 'MEDIA_SET_TYPE',
            payload: mediaType
        });

        return Promise.resolve(true);
    }
}



// WEBPACK FOOTER //
// ./src/core/admin/store/actions/media.js